import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import MarkEmailUnreadOutlinedIcon from '@mui/icons-material/MarkEmailUnreadOutlined';

import { Link, useLocation } from 'react-router-dom';

import AuthLayout, { TRUE_DARK, TRUE_MUTED, primaryButtonSx } from './auth/AuthLayout';

const Verify = () => {
    // Register passes the address it just signed up with.
    const email = (useLocation().state as { email?: string } | null)?.email;

    return (
        <AuthLayout
            title={
                <>
                    <Box sx={{
                        width: 56, height: 56, borderRadius: '14px', mb: 3,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: 'linear-gradient(135deg, #14252C 0%, #4A5F68 100%)',
                    }}>
                        <MarkEmailUnreadOutlinedIcon sx={{ color: 'white', fontSize: 28 }} />
                    </Box>
                    Revisa tu correo
                </>
            }
            subtitle={
                email
                    ? <>Enviamos un enlace de verificación a <strong style={{ color: TRUE_DARK }}>{email}</strong>.</>
                    : 'Te enviamos un enlace para verificar tu cuenta.'
            }
        >
            <Box sx={{ bgcolor: '#F5F7FA', borderRadius: '8px', p: 2, mb: 3 }}>
                <Typography variant="body2" sx={{ color: TRUE_DARK, fontWeight: 600, fontFamily: 'Inter, sans-serif', mb: 0.5 }}>
                    ¿No lo encuentras?
                </Typography>
                <Typography variant="body2" sx={{ color: TRUE_MUTED, fontFamily: 'Inter, sans-serif' }}>
                    Revisa tu carpeta de spam o correo no deseado. El enlace abre esta aplicación y activa tu cuenta.
                </Typography>
            </Box>
            <Button component={Link} to="/login" fullWidth variant="contained" sx={primaryButtonSx}>
                Ir a iniciar sesión
            </Button>
        </AuthLayout>
    );
};

export default Verify;
